namespace GeniuzPOS.Inventory {
    export interface IcStockCountCodeRow {
        Id?: number;
        SysDocNo?: string;
        StockCountCode?: string;
        StockCountDesc?: string;
        StockCountDate?: string;
        RefDocNo?: string;
        WhsId?: string;
        WhsName?: string;
        Remark?: string;
        ApproveFg?: ApproveFgSelect;
        PostFg?: PostFgStatus;
        CreateBy?: string;
        CreateDate?: string;
        UpdateBy?: string;
        LastUpdate?: string;
        IcStockCountTranList?: IcStockCountTranRow[];
        ApproveBy?: string;
        ApproveDate?: string;
        PostDate?: string;
        CancelFg?: CancelFgstatus;
    }

    export namespace IcStockCountCodeRow {
        export const idProperty = 'SysDocNo';
        export const nameProperty = 'StockCountCode';
        export const localTextPrefix = 'Inventory.IcStockCountCode';
        export const lookupKey = 'Inventory.IcStockCountCode';

        export function getLookup(): Q.Lookup<IcStockCountCodeRow> {
            return Q.getLookup<IcStockCountCodeRow>('Inventory.IcStockCountCode');
        }
        export const deletePermission = '2Inventory:ตรวจนับ:บันทึกรายการ:Modify';
        export const insertPermission = '2Inventory:ตรวจนับ:บันทึกรายการ:Modify';
        export const readPermission = '2Inventory:ตรวจนับ:บันทึกรายการ:View';
        export const updatePermission = '2Inventory:ตรวจนับ:บันทึกรายการ:Modify';

        export declare const enum Fields {
            Id = "Id",
            SysDocNo = "SysDocNo",
            StockCountCode = "StockCountCode",
            StockCountDesc = "StockCountDesc",
            StockCountDate = "StockCountDate",
            RefDocNo = "RefDocNo",
            WhsId = "WhsId",
            WhsName = "WhsName",
            Remark = "Remark",
            ApproveFg = "ApproveFg",
            PostFg = "PostFg",
            CreateBy = "CreateBy",
            CreateDate = "CreateDate",
            UpdateBy = "UpdateBy",
            LastUpdate = "LastUpdate",
            IcStockCountTranList = "IcStockCountTranList",
            ApproveBy = "ApproveBy",
            ApproveDate = "ApproveDate",
            PostDate = "PostDate",
            CancelFg = "CancelFg"
        }
    }
}
